// Icon.tsx
import React from "react";
import { IconProps } from "../../../Interface/interface";

const Icon: React.FC<IconProps> = ({ src, alt, className, style }) => {
  return (
    <img src={src} alt={alt} className={className} style={style}></img>
  );
};

export default Icon;